import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 41 41"
    width="41"
    height="41"
  >
    <path
      fill="#009A44"
      fillRule="nonzero"
      d="M26.525 32.025c-1.331 0-2.94-.334-4.708-1.001-3.877-1.462-8.095-4.35-11.877-8.133-3.783-3.783-6.672-8.002-8.135-11.879C.476 7.487.473 4.594 1.798 3.27c.19-.19.384-.395.584-.606C3.591 1.393 4.957-.037 6.767.027c1.248.052 2.456.827 3.694 2.367 3.657 4.548 2.009 6.17.1 8.049l-.337.333c-.312.312-.902 1.758 4.585 7.245 1.791 1.791 3.319 3.102 4.54 3.895.768.5 2.142 1.255 2.706.691l.34-.342c1.876-1.904 3.497-3.548 8.043.106 1.54 1.238 2.314 2.446 2.365 3.695.075 1.81-1.366 3.179-2.639 4.386-.21.2-.414.394-.605.584-.657.659-1.709.989-3.034.989zM6.638 1.101c-1.286 0-2.448 1.223-3.475 2.305-.207.217-.407.428-.604.625-.987.986-.887 3.577.254 6.602 1.41 3.737 4.211 7.82 7.89 11.498 3.676 3.676 7.757 6.478 11.495 7.887 3.026 1.143 5.617 1.24 6.602.255.196-.197.407-.397.625-.603 1.105-1.05 2.36-2.24 2.304-3.562-.037-.907-.698-1.883-1.964-2.9-3.788-3.046-4.847-1.97-6.603-.19l-.345.348c-.84.84-2.203.654-4.054-.549-1.284-.835-2.87-2.193-4.713-4.037-4.554-4.553-6.01-7.34-4.586-8.768l.344-.339c1.785-1.756 2.863-2.817-.184-6.606-1.02-1.265-1.995-1.926-2.902-1.965h-.084z"
    />
  </svg>
);
